module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/ENGLISH LITERATURE-a4d58b6dc81684e24b75b9b5f897383a.png";